import { ApiError } from '@/api/client'
import type { ErrorEntry } from '@/types/error'

type TranslateFunction = (key: string, options?: Record<string, unknown>) => string

export function translateErrorCode(entry: ErrorEntry, t: TranslateFunction, fallback?: string): string {
  const translated = t(`errorCodes.${entry.code}`, { ...entry.params ?? {}, defaultValue: '' })
  if (translated) {
    return translated
  }
  return fallback ?? entry.detail
}

export function getErrorMessage(error: Error, t: TranslateFunction): string {
  if (error instanceof ApiError) {
    return translateErrorCode({ code: error.code, detail: error.message, params: error.params }, t)
  }
  return error.message
}
